import script from "./LoginOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginOverlay.vue?vue&type=script&setup=true&lang=js"

import "./LoginOverlay.vue?vue&type=style&index=0&id=ad2006d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad2006d6"]])

export default __exports__